import { FC, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useUsersApi } from "../../http/users/api";
import Header from "../ui/Header";
import Panel from "../ui/Panel";
import UserForm, { UserFormBody } from "./UserForm";

const NewUser: FC = () => {
  const navigate = useNavigate();
  const i18n = useI18n();
  const usersApi = useUsersApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (formBody: UserFormBody) => {
    setIsSubmitting(true);
    try {
      const response = await usersApi.insertAdminUser({
        firstName: formBody.firstName,
        lastName: formBody.lastName,
        email: formBody.email,
        birthDate: formBody.birthDate,
        distanceInMiles: formBody.measurmentType?.value == "imperial",
        hidden: formBody.hidden,
        isRothoblaasUser: formBody.isRothoblaasUser,
        areNotificationsDisabled: formBody.areNotificationsDisabled,
      });
      dispatch(showSuccessNotification(i18n.t));
      navigate(`/admin/users/${response.id}`);
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header title={i18n.t.users.new} />
      <Panel>
        <UserForm onSubmit={onSubmit} isDisabled={isSubmitting} />
      </Panel>
    </>
  );
};

export default NewUser;
